module.exports = __webpack_public_path__ + "static/id_card_front.9ffc59bf.png";